export const radioButtonData = [
  { label: 'The number was blocked', id: 'number-blocked', isFocused: true },
  { label: "I can't remember", id: 'cant-remember' },
  {
    label: 'They called from the number of the company/organisation they were impersonating',
    id: 'impersonated-number',
  },
  {
    label: "A random number I didn't recognise",
    id: 'unrecognised-number',
  },
]

export const haveContactPillButtonData = {
  online: {
    title: 'Do you have a link to the website or social media page?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/9b12277746a7-tool-icon-website.jpg',
    },
  },
  email: {
    title: 'Do you have the email address that the email was sent from?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/ca6d176c1944-tool-icon-web-question.jpg',
    },
  },
  textMessage: {
    title: 'Do you have the number the text came from?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/a57448822385-tooliconphonenumber.jpg',
    },
  },
  whatsapp: {
    title: 'Do you have the number the WhatsApp came from?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/a57448822385-tooliconphonenumber.jpg',
    },
  },
  social: {
    title: 'Do you have the website address?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/9b12277746a7-tool-icon-website.jpg',
    },
  },
}
